module.exports = __webpack_public_path__ + "img/ben_no.48f5b684.png";